import React, { useEffect } from 'react'
import { useVsgSdk } from 'alelo-logic/contexts/vsgSdkContext'
import {
  hasNumbers,
  validatePasswordLength,
  validateLetterLow,
  validateLetterUpper,
  validateLetterEspecial
} from 'alelo-logic/utils'

import { Container } from './styles'

const CreateNewPassword = props => {
  document.title = 'Minha Veloe | Cadastrar senha'
  const vsgSdk = useVsgSdk()
  const searchParams = new URLSearchParams(props.location.search)
  const token = searchParams.get('token')

  useEffect(() => {
    const createNewPasswordComponent = vsgSdk.renderizarAlterarSenha({
      background: '/images/wronguser.png',
      title: 'Criar nova senha',
      description:
        'Agora é só você pensar em uma nova senha para acessar a Veloe. Lembre-se, sua nova senha deve ter no mínimo seis caracteres, pelo menos uma letra e um número.',
      token: token,
      passwordRules: [
        {
          rule: 'Entre 6 e 14 caracteres',
          validate: validatePasswordLength
        },
        {
          rule: 'Uma letra minúscula',
          validate: password => password && !validateLetterLow(password)
        },
        {
          rule: 'Uma letra maiúscula',
          validate: password => password && !validateLetterUpper(password)
        },
        {
          rule: 'Um número',
          validate: hasNumbers
        },
        {
          rule: 'Um caractere especial dentre os seguintes: _!#$@*=-;,/{}:?',
          validate: password => password && !validateLetterEspecial(password)
        }
      ]
    })

    createNewPasswordComponent.on('cancelar', () => {
      props.history.push('/conta/login')
    })

    createNewPasswordComponent.on('token-expirado', () => {
      props.history.push('/conta/login')
    })

    createNewPasswordComponent.on('sucesso', () => {
      props.history.push('/conta/login')
    })
  }, [vsgSdk, token])

  return <Container id="vsg-alterar-senha" data-testid="vsg-alterar-senha" />
}

export default CreateNewPassword
